export const shortDateFormat = 'd MMMM yyyy';

export const longDateFormat = 'dd MMMM yyyy';
